import { useState, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Root from "./routes/Root";
import Home from "./routes/Home";
import About from "./routes/About";
import Bibliography from "./routes/Bibliography";
import Submissions from "./routes/Submissions";
import MainNavigation from "./components/shared/MainNavigation";


const Gallery = lazy(() => import("./routes/Gallery"));
const GalleryDetails = lazy(() => import("./routes/GalleryDetails"));
const GalleryArtist = lazy(() => import("./routes/GalleryArtist"));
const GalleryOriginal = lazy(() => import("./routes/GalleryOriginal"));
const NotFound = lazy(() => import("./routes/NotFound"));
//const NotFoundComingSoon = lazy(() => import("./routes/NotFoundComingSoon"));


function App() {
  const [showNav, setShowNav] = useState(true);

  return (
    <>

      <BrowserRouter>
        {
          showNav && <MainNavigation />
        }

        <Suspense fallback={<p>Loading...</p>} >

          <Routes>
            <Route path="/" element={<Root />} />
            <Route element={<Home funcNav={setShowNav} />} index />
            {/* Publish these routes when the website is ready to go live.*/}
            <Route path="/about" element={<About funcNav={setShowNav} />} />
            <Route path="/gallery" element={<Gallery funcNav={setShowNav} />} />
            <Route path="/gallery/:memeUrlSlug" element={<GalleryDetails funcNav={setShowNav} />} />
            <Route path="/gallery/:memeUrlSlug/:artistUrlSlug" element={<GalleryArtist funcNav={setShowNav} />} />
            <Route path="/gallery/:memeUrlSlug/original" element={<GalleryOriginal funcNav={setShowNav} />} />
            <Route path="/bibliography" element={<Bibliography funcNav={setShowNav} />} />
            <Route path="/submissions" element={<Submissions funcNav={setShowNav} />} />
            <Route path="*" element={<NotFound funcNav={setShowNav} />} />
            {/* comment out routes above before website is ready to go live* /}

          {/* Publish this route before website is ready to go live and comment out other routes
          <Route path="*" element={<NotFoundComingSoon funcNav={setShowNav} />} /> 
          */}
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Analytics debug={false} />
    </>
  );
}

export default App;
